import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import FolderOpen from '@material-ui/icons/FolderOpen';
import SignalWifiOff from '@material-ui/icons/SignalWifiOff';
import PropTypes from 'prop-types';
var useStyle = makeStyles(function () {
  return {
    container: {
      display: 'flex'
      /* establish flex container */
      ,
      flexGrow: 1,
      flexDirection: 'column'
      /* make main axis vertical */
      ,
      justifyContent: 'center'
      /* center items vertically, in this case */
      ,
      alignItems: 'center'
      /* center items horizontally, in this case */

    },
    box: {
      textAlign: 'center'
    },
    icon: {
      marginTop: '10px',
      fontSize: 70
    }
  };
});
var mensagensTitulo = ['Hummmmm', 'Alowwww', 'Xiiiiii', 'Eitaaaaa', 'Nooossa'];
export var EmptyState = function EmptyState(_ref) {
  var _ref$IconComponent = _ref.IconComponent,
      IconComponent = _ref$IconComponent === void 0 ? FolderOpen : _ref$IconComponent,
      titleMessage = _ref.titleMessage,
      message = _ref.message,
      noConnectionTitle = _ref.noConnectionTitle,
      offlineMessage = _ref.offlineMessage,
      children = _ref.children;
  var classes = useStyle();
  var messagemTitulo = titleMessage || mensagensTitulo[Math.floor(Math.random() * mensagensTitulo.length)];
  var Icon = navigator.onLine ? IconComponent : SignalWifiOff;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "disabled",
    className: classes.icon
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, navigator.onLine ? messagemTitulo : noConnectionTitle, "..."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    gutterBottom: true
  }, navigator.onLine ? message : offlineMessage), children));
};
EmptyState.defaultProps = {
  titleMessage: null,
  message: 'Não há nada por aqui ainda.',
  offlineMessage: 'Podem existir resultados, mas por enquanto não temos nada.',
  noConnectionTitle: 'Sem conexão',
  IconComponent: FolderOpen
};
EmptyState.propTypes = {
  /** Icon to be displayed */
  IconComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /** Custom message title */
  titleMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),

  /** Custom message */
  message: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),

  /** Custom message title when no connection available */
  noConnectionTitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),

  /** Custom message when offline */
  offlineMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};
export default EmptyState;